import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const get = async () => await dponetAPI.get('/promotional_banner')

const promotionalBanners = { get }

export default promotionalBanners
